<template>
  <div class="ibc-user-certificate common-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="userList"
      :first-table-col="firstTableCol"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="userPaging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="status" slot-scope="{ param }">
        <span
          class="cert-status"
          :class="param.row.Status === 'normal' ? 'is-normal' : 'is-cancel'"
          >{{ formatStatus(param.row.Status) || $constants.EMPTY }}</span
        >
      </template>
    </normal-table>
    <init-user ref="initUser" @update:list="getList()"></init-user>
    <see-dialog ref="seeDialog"></see-dialog>
    <import-user ref="importUser" @update:list="getList()"></import-user>
    <gen-user ref="genUser" @update:list="getList()"></gen-user>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import initUser from './components/initUser'
import seeDialog from './components/seeDialog'
import importUser from './components/importUser'
import genUser from './components/genUser'

export default {
  name: 'User',
  components: {
    initUser,
    seeDialog,
    importUser,
    genUser
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成IBC用户证书',
          click: () => {
            return this.genUser()
          },
          icon: 'icon-gen',
          auth: auth.certificate.IBCAuth.userCert.createUserCert
        },
        // {
        //   btnContent: '导入IBC用户证书',
        //   click: () => {
        //     return this.importUser()
        //   },
        //   icon: 'icon-import',
        //   auth: auth.certificate.IBCAuth.userCert.importUserCert
        // },
        // {
        //   btnContent: '申请IBC用户证书',
        //   click: () => {
        //     return this.initUser()
        //   },
        //   icon: 'icon-apply',
        //   auth: auth.certificate.IBCAuth.userCert.requireUserCert
        // }
      ],
      // 设置table的列
      tableCol: [
        { 
          prop: 'OrgId', 
          label: '组织ID',
          minWidth: 139 
        },
        { 
          prop: 'UserName', 
          label: '用户名称',
          minWidth: 158 
        },
        {
          prop: 'CertUse',
          label: '证书用途',
          formatter: row => {
            return this.formatUsage(row.CertUse)
          },
          minWidth: 141 
        },
        { 
          prop: 'OrgName', 
          label: '所属组织',
          minWidth: 145 
        },
        {
          prop: 'CertType',
          label: '用户角色',
          minWidth: 76,
          formatter: row => {
            return this.formatRole(row.CertType)
          }
        },
        // {
        //   prop: 'Algorithm',
        //   label: '密码算法',
        //   formatter: row => {
        //     return this.formatAlgo(row.Algorithm)
        //   }
        // },
        {
          prop: 'Status',
          label: '状态',
          minWidth: 136,
          slotName: 'status',
          align: 'center',
          headerAlign: 'center'
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 162
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          showText: true,
          click: (row, col, cellValue) => {
            return this.getInfo(row)
          },
          icon: 'icon-check'
        },
        {
          text: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        },
        {
          text: '撤销',
          showText: true,
          click: (row, col, cellValue) => {
            return this.delInfo(row)
          },
          icon: 'icon-cancel',
          formatter: row => {
            return this.judgeShow(row)
          }
        }
      ],
      operateCol: {
        minWidth: 208
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      }
    }
  },
  computed: {
    ...mapState({
      userList: state => state.certificate.user_list,
      userPaging: state => state.certificate.user_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getCertUserLists']),
    getList(limit = 20, offset = 0, name) {
      let params = {
        offset,
        limit,
        certType: 2,
        name,
        chainMode: 'permissionedWithIBC'
      }
      this.getCertUserLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data // TODO: 这里的 offset 实际是 page，后续需要修改一下 src/components/commonTable/index.vue 中的 this.$emit('pagination') 的 data
      let limit2 = limit * 2 // IBC 同一份完整的证书，包含sign证书和tls证书，二者分为两条数据，前端获取后会合并当做一条数据，所以每次取2倍的数据量
      this.getList(limit2, offset * limit2)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    formatAlgo(algo) {
      // return algo === 0 ? '国密' : 'ECDSA'
      switch (algo) {
        case 0:
          return '国密'
        case 1:
          return 'ECDSA'
        case 2:
          return 'IBC'
        default:
          return '未知算法:' + algo
      }
    },
    formatUsage(usage) {
      // switch (usage) {
      //   case 0:
      //     return '签名'
      //   case 1:
      //     return '通信'
      //   case 2:
      //     return 'PEM'
      //   case 3:
      //     return 'IBC签名'
      //   case 4:
      //     return 'IBC通信'
      //   default:
      //     return '未知用途:' + usage
      // }

      return 'IBC通信/IBC签名'
    },
    formatRole(role) {
      let type = ['组织证书', '管理员', '普通用户', '共识节点', '普通节点', '轻用户', '根证书']
      return type[role - 1]
    },
    formatStatus(status) {
      return status === 'normal' ? '正常' : '已撤销'
    },
    initUser() {
      this.$refs.initUser.handleOpen()
    },
    importUser() {
      this.$refs.importUser.handleOpen()
    },
    getInfo(row) {
      let data = {
        cert: row.Cert,
        title: row.UserName,
        type: 'IBC',
        name: row.UserName,
        id: row.OrgId,
        typeStr: 'admin',
        index: '_USER_',
        createDate: this.formatTime(row), //创建时间
        sign: row.Cert3,
        communication: row.Cert4,
        endDate: this.$utils.dateFormatStamp('YYYY-mm-dd HH:MM', new Date()) //创建时间+100年
      }
      let dataMeta = [{
        label: 'UserName',
        prop: 'name'
      }, {
        label: 'OrgId',
        prop: 'id'
      }, {
        label: 'Type',
        prop: 'typeStr'
      }, {
        label: 'ValidateBegin',
        prop: 'createDate'
      }, {
        label: 'ValidateEnd',
        prop: 'endDate'
      }];

      this.$refs.seeDialog.handleOpen(data, dataMeta)
    },
    downloadFile(row) {
      const nameSign = row.OrgId + '_USER_' + row.UserName + '签名.key'
      const nameCommunication = row.OrgId + '_USER_' + row.UserName + '通信.key'
      this.$utils.createFileAndDownload(nameSign, row.Cert3)
      this.$utils.createFileAndDownload(nameCommunication, row.Cert4)
    },
    // 判断撤销按钮显示与隐藏
    judgeShow(row) {
      return row.Source === 'ca_service' && row.Status === 'normal'
    },
    delInfo(row) {
      this.$prompt('请输入用户证书撤销理由', '撤销证书', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入撤销原因'
      })
        .then(({ value }) => {
          let param = {
            certId: row.id,
            reason: value
          }
          this.$apis.certificate.revokeCert(param).then(res => {
            this.$message({
              type: 'success',
              message: `用户证书撤销成功！`
            })
            this.refresh()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消撤销'
          })
        })
    },
    refresh() {
      const { offset, limit } = this.userPaging
      this.getList(limit * 2, offset * 2)
    },
    genUser() {
      this.$refs.genUser.handleOpen()
    }
  }
}
</script>

<style scoped lang="scss">
.ibc-user-certificate.common-certificate {
  .normal-table-wrap {
    height: 100%;
    min-height: var(--common-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);

        .cert-status {
          padding: var(--common-certificate-list-status-padding);
          display: inline-block;
          &.is-normal {
            color: var(--base-color-success);
          }

          &.is-cancel {
            color: var(--base-color-danger);
            background-color: rgba(233, 87, 87, 0.34);
          }
        }
      }
    }
  }
}
</style>
